import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import * as ReqType from '../../types/ServerRequests';
import { Redirect } from 'react-router';
import { CreateEvent } from './internalComponents/CreateEvent';
import { EventService } from '../../services/EventService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
}

/**
 * interface State (l'état interne de la classe CreateEventPage)
 */
interface State {
    redirect: boolean;
    event: ReqType.Event;
}

/**
 * cette classe permet de creer un evenement
 */
export class CreateEventPage extends React.Component {
    props: Props;
    state: State;

    /**
     *
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            redirect: false,
            event: EventService.getInstance().getDefaultEvent(),
        };
    }

    /**
     * le rendu de la classe CreateEventPage
     * @returns {JSX.Element}
     */
    render() {
        if (this.state.redirect) {
            return <Redirect to={'/schedule'} />;
        }
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                ]}
            >
                <div style={{paddingTop: '20px', paddingBottom: '20px'}}>
                    <CreateEvent event={this.state.event} changeEvent={this.changeEvent} redirect={this.redirect}/>
                </div>
            </PageChorinitia>
        );
    }

    /**
     * change l'event du stat avec event passer en paramettre
     * @param {Event} e
     */
    private changeEvent = (e: ReqType.Event) => {
        this.setState({event: e});
    }

    /**
     * change le state a true pour la redirection
     */
    private redirect = () => {
        this.setState({redirect: true});
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/CreateEventPage.tsx